const getters = {
  permissions: state => state.permission.permissionData,
  permissionsList: state => state.permission.permissionList,
  menuData: state => state.permission.menuData,
  styleData: state => state.permission.styleData,
  userInfo: state => state.permission.userInfo,
}
export default getters
